module.exports = __webpack_public_path__ + "img/flag_116.21461aa8.png";